export default "__VITE_ASSET__UwChovIl__"